module.exports = __webpack_public_path__ + "img/section1-1-mobile.0281b13f.png";